import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import {
  Typography,
  TypographyProps,
  Link,
  LinkProps,
  Card,
  Grid,
  Box,
  BoxProps,
  Button,
  ButtonProps,
  Accordion,
  AccordionSummary,
  AccordionSummaryProps,
  AccordionDetails,
  AccordionDetailsProps,
} from '@mui/material';

import { DataGrid, DataGridProps } from '@mui/x-data-grid';
import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro';

export const ComponentPageContainer = styled('div')(({ theme }) => ({
  borderTopLeftRadius: '15px',
  transition: 'ease-in',
  transitionDelay: '100ms',
  background: theme.palette.background.paper,
  height: 'inherit',
  paddingTop: '64px',
}));

export const PageContainer = styled('div')(({ theme }) => ({
  padding: '40px',
}));

export const PageHeader = styled(Typography)<TypographyProps>(({ theme }) => ({
  variant: 'h4',
  component: 'div',
  display: 'flex',
  alignItems: 'center',
  height: '32px',
  fontSize: '24px',
  fontWeight: 600,
  marginBottom: '48px',
  color: theme.palette.text.primary,
}));

export const BreadcrumbContainer = styled(Box)(({ theme }) => ({
  marginBottom: '16px',
}));

export const BreadcrumbLinkComponent = styled(Link)<LinkProps>(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

export const DataTableContainer = styled('div')(({ theme }) => ({
  marginTop: '24px',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
}));

export const MetricCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[4],
  },
}));

export const MetricValue = styled(Typography)(({ theme }) => ({
  fontSize: '2.25rem',
  fontWeight: 700,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
}));

export const MetricLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

export const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  borderRadius: theme.shape.borderRadius,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    opacity: 0.9,
  },
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '400px',
  backgroundColor: theme.palette.background.default,
}));

export const ErrorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '400px',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.secondary,
}));

export const NoDataContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '300px',
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
}));
